import { FeatureFlag } from '@mews-commander/enums';
import { EnterpriseLink } from '@mews-commander/ui';
import { lt, useFeatureFlag } from '@mews/framework';
import { DropDownButton, IconName, DropdownItem, Icon } from '@optimus-web/core';

export const AddButton = ({ customerId }: { customerId: string }) => {
    const isContractingDocumentGenerationEnabled = useFeatureFlag(FeatureFlag.contractingDocumentGenerationEnabled);

    return (
        <DropDownButton
            size="small"
            label={lt('ContractGuestProfileTemplateAddButtonLabel')}
            icon={IconName.PlusSimple}
            type="button"
        >
            {isContractingDocumentGenerationEnabled && (
                <EnterpriseLink
                    standalone
                    variant="basic"
                    to="ReservationContracts/Generate"
                    underline={false}
                    search={{ customerId }}
                >
                    <DropdownItem
                        leftDetail={<Icon value={IconName.ActionLog} />}
                        label={lt('ContractGenerateFromTemplateButtonLabel')}
                    />
                </EnterpriseLink>
            )}
            <DropdownItem
                leftDetail={<Icon value={IconName.Upload} />}
                label={lt('ContractsUploadFileLabel')}
                onClick={() => {}}
            />
        </DropDownButton>
    );
};
